import React from 'react';
import { styled } from '@compiled/react';
import { components, type ControlProps } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import type { StatusPickerOption } from '../../types.tsx';

export const ControlComponent = ({
	innerProps,
	innerRef,
	...props
}: ControlProps<StatusPickerOption, false>) => (
	<ControlComponentWrapper ref={innerRef}>
		<components.Control
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			{...(props as ControlProps<StatusPickerOption, false>)}
			innerProps={innerProps}
		/>
	</ControlComponentWrapper>
);

// Styles taken from PopupSelect/components.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ControlComponentWrapper = styled.div({
	padding: `${token('space.100', '8px')} ${token('space.100', '8px')} ${token('space.050', '4px')}`,
});
